import styles from './styles.scss';
import { rm } from 'utils';
import { Button } from 'components/Button';

export const ScrollToContent = (): JSX.Element => (
  <div className={styles.scrollToContent}>
    <Button size="medium" appearance="link" href="#mca">
      {rm('layout_scroll_to_content')}
    </Button>
    <Button size="medium" appearance="link" href="#search">
      {rm('layout_scroll_to_search')}
    </Button>
  </div>
);
